import React from 'react';
import HomeHero from '../../components/HomeHero/HomeHero';
import HomeAbout from '../../components/HomeAbout/HomeAbout';
import HomeServices from '../../components/HomeServices/HomeServices';
import ChooseUs from '../../components/ChooseUs/ChooseUs';
import Testimonials from '../../components/Testimonials/Testimonials';
import Questions from '../../components/Questions/Questions';
import HomeContact from '../../components/HomeContact/HomeContact';
import { Helmet } from 'react-helmet-async';

const Home = () => {

    return (
        <>
            <Helmet>
                {/* Title */}
                <title>Financial Advisor & Wealth Management Experts in Lewisham, Sydney NSW | PFGS</title>

                {/* Meta Description */}
                <meta name="description"
                    content="Expert financial advisors in Sydney helping you plan, invest & grow wealth. Tailored financial planning, tax, and wealth management by PFGS."
                />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pfgs.com.au/" />

                {/* Meta Robots */}
                <meta
                    name="robots"
                    content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
                />

                {/* Open Graph (Facebook / LinkedIn / WhatsApp) */}
                <meta property="og:title" content="PFGS | Financial Planning & Wealth Management in Australia" />
                <meta property="og:description" content="Expert financial advisors in Australia helping you with retirement planning, superannuation, investments, and insurance strategies." />
                <meta property="og:url" content="https://pfgs.com.au/" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://pfgs.com.au/pfgs-preview.jpg" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="PFGS | Financial Planning & Wealth Management in Australia" />
                <meta name="twitter:description" content="Trusted financial planners in Australia offering tailored solutions for wealth management, retirement, superannuation, and investments." />
                <meta name="twitter:image" content="https://pfgs.com.au/pfgs-preview.jpg" />
            </Helmet>
            <div className="home-page">
                <HomeHero />
                <HomeAbout />
                <HomeServices />
                <ChooseUs />
                <Testimonials />
                <HomeContact />
                <Questions />
            </div>
        </>
    );
};

export default Home;
